// Reducer for homepage actions

import * as ActionTypes from '../constants/action_types'
import { LS_HOMEPAGE_KEY } from '../constants/local_storage'
import {
  homepageList,
  homepageTopicDetails,
  homepageTopicPlan,
  homepageWhatsNew,
  homepageDemographics,
  homepageEngagementNetwork,
  homepageTopShows,
  homepageTrendingVideos,
  homepageAnticipatedShows,
  DefaultHomepageListState
} from './homepageModule_reducer'

export const DefaultHomepageState = {
  list: { ...DefaultHomepageListState },
  byId: {}
}

export const homepageById = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_HOMEPAGE_TOPIC_DETAILS:
    case ActionTypes.RECEIVE_HOMEPAGE_TOPIC_DETAILS:
    case ActionTypes.REQUEST_HOMEPAGE_TOPIC_DETAILS_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_TOPIC_DETAILS:
      return {
        ...state,
        homepageDetails: homepageTopicDetails(state.details, action)
      }
    case ActionTypes.REQUEST_HOMEPAGE_TOPIC_PLAN:
    case ActionTypes.RECEIVE_HOMEPAGE_TOPIC_PLAN:
    case ActionTypes.REQUEST_HOMEPAGE_TOPIC_PLAN_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_TOPIC_PLAN:
      return {
        ...state,
        homepagePlan: homepageTopicPlan(state.details, action)
      }
    case ActionTypes.REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK:
    case ActionTypes.RECEIVE_HOMEPAGE_ENGAGEMENT_NETWORK:
    case ActionTypes.REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_ENGAGEMENT_NETWORK:
      return {
        ...state,
        engagementNetwork: homepageEngagementNetwork(state.details, action)
      }
    case ActionTypes.REQUEST_HOMEPAGE_DEMOGRAPHICS:
    case ActionTypes.RECEIVE_HOMEPAGE_DEMOGRAPHICS:
    case ActionTypes.REQUEST_HOMEPAGE_DEMOGRAPHICS_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_DEMOGRAPHICS:
      return {
        ...state,
        demographics: homepageDemographics(state.details, action)
      }
    case ActionTypes.REQUEST_HOMEPAGE_WHATS_NEW:
    case ActionTypes.RECEIVE_HOMEPAGE_WHATS_NEW:
    case ActionTypes.REQUEST_HOMEPAGE_WHATS_NEW_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_WHATS_NEW:
      return {
        ...state,
        whatsNew: homepageWhatsNew(state.details, action)
      }
    case ActionTypes.REQUEST_HOMEPAGE_TOP_SHOWS:
    case ActionTypes.REQUEST_HOMEPAGE_TOP_SHOWS_FAILURE:
    case ActionTypes.RECEIVE_HOMEPAGE_TOP_SHOWS:
    case ActionTypes.INVALIDATE_HOMEPAGE_TOP_SHOWS:
      return {
        ...state,
        topShows: homepageTopShows(state.details, action)
      }
    case ActionTypes.REQUEST_HOMEPAGE_TRENDING_VIDEOS:
    case ActionTypes.REQUEST_HOMEPAGE_TRENDING_VIDEOS_FAILURE:
    case ActionTypes.RECEIVE_HOMEPAGE_TRENDING_VIDEOS:
    case ActionTypes.INVALIDATE_HOMEPAGE_TRENDING_VIDEOS:
      return {
        ...state,
        trendingVideos: homepageTrendingVideos(state.details, action)
      }
    case ActionTypes.REQUEST_HOMEPAGE_ANTICIPATED_SHOWS:
    case ActionTypes.REQUEST_HOMEPAGE_ANTICIPATED_SHOWS_FAILURE:
    case ActionTypes.RECEIVE_HOMEPAGE_ANTICIPATED_SHOWS:
    case ActionTypes.INVALIDATE_HOMEPAGE_ANTICIPATED_SHOWS:
      return {
        ...state,
        anticipatedShows: homepageAnticipatedShows(state.details, action)
      }
    default:
      return state
  }
}

export const homepage = (state = DefaultHomepageState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_HOMEPAGE:
    case ActionTypes.REQUEST_HOMEPAGE_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE:
      return {
        ...state,
        list: homepageList(state.list, action)
      }
    case ActionTypes.RECEIVE_HOMEPAGE:
      const response = {
        details: action.response
      }
      localStorage.setItem(LS_HOMEPAGE_KEY, JSON.stringify(response))
      return {
        ...state,
        list: homepageList(state.list, action)
      }
    case ActionTypes.REQUEST_HOMEPAGE_TOPIC_DETAILS:
    case ActionTypes.RECEIVE_HOMEPAGE_TOPIC_DETAILS:
    case ActionTypes.REQUEST_HOMEPAGE_TOPIC_DETAILS_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_TOPIC_DETAILS:
    case ActionTypes.REQUEST_HOMEPAGE_TOPIC_PLAN:
    case ActionTypes.RECEIVE_HOMEPAGE_TOPIC_PLAN:
    case ActionTypes.REQUEST_HOMEPAGE_TOPIC_PLAN_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_TOPIC_PLAN:
    case ActionTypes.REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK:
    case ActionTypes.RECEIVE_HOMEPAGE_ENGAGEMENT_NETWORK:
    case ActionTypes.REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_ENGAGEMENT_NETWORK:
    case ActionTypes.REQUEST_HOMEPAGE_DEMOGRAPHICS:
    case ActionTypes.RECEIVE_HOMEPAGE_DEMOGRAPHICS:
    case ActionTypes.REQUEST_HOMEPAGE_DEMOGRAPHICS_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_DEMOGRAPHICS:
    case ActionTypes.REQUEST_HOMEPAGE_WHATS_NEW:
    case ActionTypes.RECEIVE_HOMEPAGE_WHATS_NEW:
    case ActionTypes.REQUEST_HOMEPAGE_WHATS_NEW_FAILURE:
    case ActionTypes.INVALIDATE_HOMEPAGE_WHATS_NEW:
    case ActionTypes.REQUEST_HOMEPAGE_TOP_SHOWS:
    case ActionTypes.REQUEST_HOMEPAGE_TOP_SHOWS_FAILURE:
    case ActionTypes.RECEIVE_HOMEPAGE_TOP_SHOWS:
    case ActionTypes.INVALIDATE_HOMEPAGE_TOP_SHOWS:
    case ActionTypes.REQUEST_HOMEPAGE_TRENDING_VIDEOS:
    case ActionTypes.REQUEST_HOMEPAGE_TRENDING_VIDEOS_FAILURE:
    case ActionTypes.RECEIVE_HOMEPAGE_TRENDING_VIDEOS:
    case ActionTypes.INVALIDATE_HOMEPAGE_TRENDING_VIDEOS:
    case ActionTypes.REQUEST_HOMEPAGE_ANTICIPATED_SHOWS:
    case ActionTypes.REQUEST_HOMEPAGE_ANTICIPATED_SHOWS_FAILURE:
    case ActionTypes.RECEIVE_HOMEPAGE_ANTICIPATED_SHOWS:
    case ActionTypes.INVALIDATE_HOMEPAGE_ANTICIPATED_SHOWS:
      if (action.topicId) {
        return {
          ...state,
          byId: {
            ...state.byId,
            [action.topicId]: homepageById(state.byId[action.topicId], action)
          }
        }
      } else {
        console.warn('Topic action fired without a topic id:', action)
        return state
      }
    default:
      return state
    }
}